define('bindingHandlers/dynamicWidth',[
    'lib/knockout',
    'jquery'
], function (ko, $) {
    'use strict';

    /**
     * Sets the width of a DOM element to the value provided by the valueAccessor;
     * useful for building progress bars.
     *
     * <div class="progress-bar" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100"
     *      data-bind="dynamicWidth: percentComplete"> </div>
     *
     * Parameters:
     * The binding parameter should be an integer value representing the percentage.
     */
    ko.bindingHandlers.dynamicWidth = {
        update: function (element, valueAccessor) {
            $(element).width(ko.unwrap(valueAccessor()) + '%');
        }
    };
});

